"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoundingMethod = void 0;
var RoundingMethod;
(function (RoundingMethod) {
    RoundingMethod["ROUND"] = "ROUND";
    RoundingMethod["FLOOR"] = "FLOOR";
})(RoundingMethod || (exports.RoundingMethod = RoundingMethod = {}));
